
export const errors = {
  generic: 'ขออภัย เกิดข้อผิดพลาดที่ไม่คาดคิด',
  network: 'การเชื่อมต่อขัดข้อง กรุณาตรวจสอบอินเทอร์เน็ตของคุณ',
  insufficientFunds: {
    title: 'ยอดเงินไม่เพียงพอ',
    message: 'เครดิตใน Wallet ไม่พอสำหรับการทำรายการนี้',
    suggestion: 'กรุณาเติมเงินเพื่อดำเนินการต่อ'
  },
  quotaExceeded: {
    title: 'โควต้าเต็มแล้ว',
    message: 'สิทธิ์การใช้งานของคุณหมดแล้วสำหรับรอบบิลนี้',
    suggestion: 'กรุณาอัปเกรดแผนเพื่อขยายลิมิต'
  },
  duplicateEntry: {
    title: 'ข้อมูลซ้ำในระบบ',
    message: 'ข้อมูลนี้ (เช่น เบอร์โทร, เลขบัตร) มีอยู่ในระบบแล้ว',
    suggestion: 'ตรวจสอบว่าเคยลงทะเบียนไปแล้วหรือไม่'
  },
  notFound: {
    title: 'ไม่พบข้อมูล',
    message: 'ข้อมูลที่คุณค้นหาไม่มีอยู่จริง หรือถูกลบไปแล้ว',
    suggestion: 'ลองค้นหาด้วยคำอื่น หรือตรวจสอบความถูกต้อง'
  },
  permissionDenied: {
    title: 'ไม่มีสิทธิ์เข้าถึง',
    message: 'คุณไม่มีสิทธิ์เข้าถึงข้อมูลส่วนนี้',
    suggestion: 'กรุณาติดต่อผู้ดูแลระบบหากคุณคิดว่านี่เป็นข้อผิดพลาด'
  },
  auth: {
    invalidLogin: 'รหัสผ่านไม่ถูกต้อง',
    userNotFound: 'ไม่พบบัญชีผู้ใช้นี้ในระบบ',
    sessionExpired: 'เซสชั่นหมดอายุ กรุณาเข้าสู่ระบบใหม่'
  }
};
